var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iain-image-domain',{attrs:{"h":"216","r":"10","src":_vm.cover}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }